import { render, staticRenderFns } from "./leftBigTitle.vue?vue&type=template&id=8382c754&scoped=true&"
import script from "./leftBigTitle.vue?vue&type=script&lang=js&"
export * from "./leftBigTitle.vue?vue&type=script&lang=js&"
import style0 from "./leftBigTitle.vue?vue&type=style&index=0&id=8382c754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8382c754",
  null
  
)

export default component.exports